





























































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mdbRow, mdbCol, mdbSelect, mdbInput } from '@folky-tools/mdbvue';
import { NewSpaceData } from '@/models/shared/new-space-data';
import { is_email_valid as isEmailValid } from 'node-email-validation';
import { required, email } from 'vuelidate/lib/validators';

@Component({
    components: {
        mdbRow,
        mdbCol,
        mdbSelect,
        mdbInput
    },
    validations: {
        spaceData: {
            adminName: {required },
            adminEmail: {
                required,
                email,
                customEmail: (value, model) => {
                    if (typeof value === 'undefined' || value === null || value === '') {
                        return true;
                    }
                    return isEmailValid(value);
                }
            },
            adminPassword: {
                required,
                password: (value, model) => {
                    if (typeof value === 'undefined' || value === null || value === '') {
                        return true;
                    }
                    const containsUppercase = /[A-Z]/.test(value);
                    const containsLowercase = /[a-z]/.test(value);
                    const containsNumber = /[0-9]/.test(value);
                    const containsSpecial = /[-&!#$%^*+=?_@]/.test(value);
                    
                    return value.length >= 8 && containsUppercase && containsLowercase && containsNumber && containsSpecial;
                }
            },
            spaceName: {required },
            spacePin: {
                required,
                pin: (value, model) => {
                    if (typeof value === 'undefined' || value === null || value === '') {
                        return true;
                    }
                    return /^\d{4}$/.test(value);
                }
            }
        }
    }
})
export default class NewSpace extends Vue {
    @Prop({ type: Boolean, default: false }) private readOnly?: boolean;
    @Prop(NewSpaceData) private spaceData!: NewSpaceData;

    private hasErrors(): boolean {
        this.$v.spaceData.$touch();
        if (this.$v.spaceData.$error) {
            return true;
        }
        return false;
    }
}
